import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { TablesService } from '../../../services/tables.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { EventEmitterService } from '../../../services/event-emitter.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { debounceTime, fromEvent } from 'rxjs';
import { TablePopupComponent } from '../../../modals/table-popup/table-popup.component';
import { DeletePopupComponent } from '../../../modals/delete-popup/delete-popup.component';

@Component({
  standalone: false,
  selector: 'app-tables',
  templateUrl: './tables.component.html',
  styleUrl: './tables.component.scss',
})
export class TablesComponent implements OnInit, AfterViewInit {
  @ViewChild('searchInput') searchInput: ElementRef;
  search = '';
  tables = [];
  page = 1;
  pageSize = 10;
  totalItems = 0;
  totalPages = 1;
  loading = false;
  destoryRef = inject(DestroyRef);
  columns = [
    { header: 'name', field: 'name' },
    { header: 'branch', field: 'branchName' },
  ];

  constructor(
    private tablesService: TablesService,
    private modalService: BsModalService,
    public eventEmitterService: EventEmitterService,
  ) {
    this.eventEmitterService.invokeEvent
      .pipe(takeUntilDestroyed(this.destoryRef))
      .subscribe((event) => {
        if (event == 'call-all-tables') {
          this.resetPagination();
          this.getAllTables();
        }
      });
  }

  ngOnInit() {
    this.resetPagination();
    this.getAllTables();
  }

  ngAfterViewInit(): void {
    this.setupSearch();
  }

  resetPagination() {
    this.tables = [];
    this.page = 1;
    this.pageSize = 10;
    this.totalItems = 0;
    this.totalPages = 1;
  }

  getAllTables() {
    if (this.loading) {
      return;
    }
    this.loading = true;

    const apiData: any = {
      page: this.page,
      pageSize: this.pageSize,
    };

    if (this.search && this.search.trim().length > 0) {
      apiData.search = this.search;
    }
    this.tablesService.getAllTables(apiData).subscribe(
      (response: any) => {
        this.loading = false;

        this.tables = response.items;
        this.page = response.page;
        this.pageSize = response.pageSize;
        this.totalItems = response.totalItems;
        this.totalPages = response.totalPages;

        this.tables.forEach((item) => {
          item.branchName = item.branch ? item.branch.name : '';
        });
      },
      (error) => {
        console.log('error:');
        console.log(error);
        this.loading = false;
      },
    );
  }

  setupSearch() {
    fromEvent(this.searchInput.nativeElement, 'input')
      .pipe(debounceTime(3000))
      .subscribe((event: Event) => {
        this.resetPagination();
        this.getAllTables();
      });
  }

  setSearch(event: any) {
    this.search = event.target.value;
  }

  onPageChange(event: { page: number; pageSize: number }) {
    this.page = event.page;
    this.pageSize = event.pageSize;
    this.getAllTables();
  }

  addTable() {
    this.modalService.show(TablePopupComponent, {
      initialState: {
        title: 'new-table',
        type: 'new-table',
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  editTable(table) {
    this.modalService.show(TablePopupComponent, {
      initialState: {
        title: 'edit-table',
        type: 'edit-table',
        table: table,
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  deleteTablePopup(id) {
    this.modalService.show(DeletePopupComponent, {
      initialState: {
        title: 'delete-table',
        text: 'delete-table-text',
        id: id,
        onButtonClick: this.deleteTable.bind(this),
      },
      class: 'alert-modal modal-dialog-centered',
      backdrop: 'static',
    });
  }

  async deleteTable(id): Promise<void> {
    return new Promise((resolve, reject) => {
      this.tablesService.deleteTable(id).subscribe(
        (response) => {
          this.eventEmitterService.callAllTables();
          resolve();
        },
        (error) => {
          console.log('error:');
          console.log(error);
          reject();
        },
      );
    });
  }
}
